import React, { Component, Fragment } from 'react';

export default class HWStepComponent extends Component {
  render() {
    const { stepsArr } = this.props;

    const stepsMap = stepsArr.map((step, key) => {

      const coverSection = (
        <div className={`step-block cover ${step.coverClass}`}>
          <div className="absolute-layer">
            <div className="cover-content">
              <img src={step.contentImage} className={ step.appStoreBlock ? 'iphone' : '' } />
            </div>
          </div>
        </div>
      );

      const infoSection = (
        <div className="step-block">
          <h4 className="step-count">Step {step.stepCount}</h4>
          <h2 className="block-title">{step.stepTitle}</h2>
          <p className="block-description">
            {step.stepDescription}
          </p>
          {
            step.appStoreBlock &&
            <div className="store-info-wrapper">
              <h2 className="store-title">Download Vocalize from</h2>
              <div className="actions-wrapper">
                <a href="https://itunes.apple.com/app/id1444343928" target="_blank"><span className="store-action istore"></span></a>
                <a href="https://play.google.com/store/apps/details?id=com.vocalizemysite.vocalize" target="_blank"><span className="store-action playstore"></span></a>
              </div>
            </div>
          }
        </div>
      );

      return (
        <div className={`step-row cover-${step.coverAlignment}`} key={ key }>
          {
            (step.coverAlignment == 'left') ?
             coverSection : infoSection
          }
          {
            (step.coverAlignment == 'right') ?
             coverSection : infoSection
          }
        </div>
      );
    });

    return(
      <Fragment>{ stepsMap }</Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/landing/HWStepComponent.js